// Ana Backend API (mobil, login, profil vb.) - Port 3002
export const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3002';
export const API_URL = `${BASE_URL.replace(/\/$/, '')}/api`;

// Oyun Sunucusu API - game-server.js Port 3004 üzerinde /api/game/* rotaları
export const GAME_BASE_URL = process.env.REACT_APP_GAME_API_URL || 'http://localhost:3004';
export const GAME_API_URL = `${GAME_BASE_URL.replace(/\/$/, '')}/api`;


export const getMediaUrl = (path) => {
    if (!path) return null;
    if (path.startsWith('http')) return path;
    const cleanPath = path.startsWith('/') ? path.slice(1) : path;
    
    // Oyun resimleriyse game server'dan çek
    if (cleanPath.startsWith('uploads/games')) {
        return `${GAME_BASE_URL.replace(/\/$/, '')}/${cleanPath}`;
    }
    
    // ensure no double slashes if BASE_URL has a trailing slash or cleanPath has a leading slash
    return `${BASE_URL.replace(/\/$/, '')}/${cleanPath}`;
};

export const stripMediaUrl = (url) => {
    if (!url) return null;
    if (url.startsWith(GAME_BASE_URL)) {
        return url.substring(GAME_BASE_URL.length + 1); // +1 for the slash
    }
    if (url.startsWith(BASE_URL)) {
        return url.substring(BASE_URL.length + 1); // +1 for the slash
    }
    return url;
};

export const getAuthHeaders = (isFormData = false) => {
    const token = localStorage.getItem('token');
    const headers = isFormData ? {} : { 'Content-Type': 'application/json' };
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }
    return headers;
};

export const apiService = {
    // AUTH
    login: async (email, password) => {
        // We also want to generate a device id and send it.
        let deviceId = localStorage.getItem('device_id');
        if (!deviceId) {
            deviceId = 'web-' + Math.random().toString(36).substring(2, 15);
            localStorage.setItem('device_id', deviceId);
        }

        const response = await fetch(`${GAME_BASE_URL}/api/game/login`, {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json',
                'x-device-id': deviceId
            },
            body: JSON.stringify({ email, password })
        });
        
        let data;
        try {
            data = await response.json();
        } catch(e) {
            throw new Error('Sunucu yanıt vermedi.');
        }

        if (!response.ok || data.message !== 'enter') {
            throw new Error(data.message || 'Giriş Başarısız');
        }
        return data;
    },

    // DASHBOARD
    getDashboardStats: async () => {
        const response = await fetch(`${GAME_API_URL}/stats/dashboard`, {
            headers: getAuthHeaders()
        });
        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.message || 'Failed to fetch dashboard stats');
        }
        const data = await response.json();
        if (data && data.m) throw new Error(data.m);
        return data;
    },

    // GAMES
    getAllGames: async () => {
        const response = await fetch(`${GAME_API_URL}/games`, {
            headers: getAuthHeaders()
        });
        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.message || 'Failed to fetch games');
        }
        const data = await response.json();
        if (data && data.m) throw new Error(data.m);
        return data;
    },
    getGameById: async (id) => {
        const response = await fetch(`${GAME_API_URL}/games/${id}`, {
            headers: getAuthHeaders()
        });
        if (!response.ok) throw new Error('Failed to fetch game');
        const data = await response.json();
        if (data && data.m) throw new Error(data.m);
        return data;
    },
    createGame: async (gameData) => {
        const isFormData = gameData instanceof FormData;
        
        const response = await fetch(`${GAME_API_URL}/games`, {
            method: 'POST',
            headers: getAuthHeaders(isFormData),
            body: isFormData ? gameData : JSON.stringify(gameData)
        });
        if (!response.ok) throw new Error('Failed to create game');
        return response.json();
    },
    updateGame: async (id, gameData) => {
        const isFormData = gameData instanceof FormData;

        const response = await fetch(`${GAME_API_URL}/games/${id}`, {
            method: 'PUT',
            headers: getAuthHeaders(isFormData),
            body: isFormData ? gameData : JSON.stringify(gameData)
        });
        if (!response.ok) throw new Error('Failed to update game');
        return response.json();
    },
    deleteGame: async (id) => {
        const response = await fetch(`${GAME_API_URL}/games/${id}`, {
            method: 'DELETE',
            headers: getAuthHeaders()
        });
        if (!response.ok) throw new Error('Failed to delete game');
        return response.json();
    },

    // QUESTIONS
    getAllQuestions: async () => {
        const response = await fetch(`${GAME_API_URL}/questions`, {
            headers: getAuthHeaders()
        });
        if (!response.ok) throw new Error('Failed to fetch questions');
        const data = await response.json();
        if (data && data.m) throw new Error(data.m);
        return data;
    },
    createQuestion: async (questionData) => {
        const isFormData = questionData instanceof FormData;
        
        console.log('[apiService] createQuestion called, isFormData:', isFormData);
        
        const response = await fetch(`${GAME_API_URL}/questions`, {
            method: 'POST',
            headers: getAuthHeaders(isFormData),
            body: isFormData ? questionData : JSON.stringify(questionData),
        });
        
        console.log('[apiService] Response status:', response.status);
        
        if (!response.ok) {
            const errorText = await response.text();
            console.error('[apiService] Error response:', errorText);
            throw new Error('Failed to create question');
        }
        
        const result = await response.json();
        console.log('[apiService] Response data:', result);
        return result;
    },
    updateQuestion: async (id, questionData) => {
        const isFormData = questionData instanceof FormData;

        const response = await fetch(`${GAME_API_URL}/questions/${id}`, {
            method: 'PUT',
            headers: getAuthHeaders(isFormData),
            body: isFormData ? questionData : JSON.stringify(questionData),
        });
        if (!response.ok) throw new Error('Failed to update question');
        return response.json();
    },
    deleteQuestion: async (id) => {
        const response = await fetch(`${GAME_API_URL}/questions/${id}`, {
            method: 'DELETE',
            headers: getAuthHeaders()
        });
        if (!response.ok) throw new Error('Failed to delete question');
        return response.json();
    }
};
